import { Link } from 'react-router-dom';
import { FaWrench, FaCalendar, FaCog, FaTruck } from 'react-icons/fa';
import Car from './3d-car-with-vibrant-colors.jpg'

const Home = () => {
  return (
    <div className="min-h-screen p-2">
      {/* Hero Section */}
      <section className="relative text-white py-20">
        {/* Background Image with Overlay */}
        <div 
          className="absolute inset-0 bg-cover bg-center z-0" 
          style={{ 
            backgroundImage: `url(${Car})`,
            backgroundPosition: 'center',
          }}
        >
          {/* Overlay with gradient for better text readability */}
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 to-blue-500/70"></div>
        </div>
        
        {/* Content - positioned above the background */}
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Smart Vehicle Repair Services
            </h1>
            <p className="text-xl mb-8">
              Find nearby repair centers, book appointments, and order spare parts - all in one place.
            </p>
            <Link
              to="/repair-centers"
              className="bg-white text-blue-600 px-8 py-3 rounded-full font-semibold hover:bg-blue-50 transition-colors inline-block"
            >
              Find Repair Centers
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Our Services</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <FeatureCard
              icon={<FaWrench className="text-4xl text-blue-600" />}
              title="Find Repair Centers"
              description="Locate trusted repair centers near you with real-time availability"
              link="/repair-centers"
            />
            <FeatureCard
              icon={<FaCalendar className="text-4xl text-blue-600" />}
              title="Book Appointments"
              description="Schedule service appointments with just a few clicks"
              link="/appointments"
            />
            <FeatureCard
              icon={<FaCog className="text-4xl text-blue-600" />}
              title="Spare Parts"
              description="Order genuine spare parts from verified suppliers"
              link="/spare-parts"
            />
            <FeatureCard
              icon={<FaTruck className="text-4xl text-blue-600" />}
              title="Track Services"
              description="Real-time updates on your vehicle's service status"
              link="/track"
            />
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">How It Works</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <StepCard
              number="1"
              title="Find a Center"
              description="Search for repair centers near you and check their ratings and services"
            />
            <StepCard
              number="2"
              title="Book Service"
              description="Select your preferred time slot and book your appointment"
            />
            <StepCard
              number="3"
              title="Get Service"
              description="Drop off your vehicle and track the repair progress in real-time"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

const FeatureCard = ({ icon, title, description, link }) => (
  <Link to={link} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
    <div className="text-center">
      <div className="mb-4">{icon}</div>
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  </Link>
);

const StepCard = ({ number, title, description }) => (
  <div className="bg-white p-6 rounded-lg shadow-lg">
    <div className="flex items-center justify-center w-12 h-12 bg-blue-600 text-white rounded-full mb-4 mx-auto">
      {number}
    </div>
    <h3 className="text-xl font-semibold text-center mb-2">{title}</h3>
    <p className="text-gray-600 text-center">{description}</p>
  </div>
);

export default Home;